import React from 'react';
import { Wrench, Clock, AlertTriangle } from 'lucide-react';

const MaintenancePage = ({ message }) => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center p-6">
            {/* Particules animées en background */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-red-600/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
            </div>

            <div className="max-w-2xl w-full relative z-10">
                {/* Icône principale */}
                <div className="flex justify-center mb-8">
                    <div className="relative">
                        <div className="absolute inset-0 bg-orange-600/20 rounded-full blur-xl animate-pulse"></div>
                        <div className="relative bg-gradient-to-r from-orange-600 to-red-600 p-8 rounded-full">
                            <Wrench className="w-16 h-16 text-white animate-bounce" />
                        </div>
                    </div>
                </div>

                {/* Titre */}
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-transparent bg-clip-text">
                    Maintenance en cours
                </h1>

                {/* Message */}
                <div className="bg-white/5 backdrop-blur-xl rounded-3xl p-8 border border-white/10 mb-8">
                    <div className="flex items-start space-x-4 mb-6">
                        <AlertTriangle className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                        <p className="text-gray-300 text-lg leading-relaxed">
                            {message || 'Le site est actuellement en maintenance. Nous serons de retour bientôt !'}
                        </p>
                    </div>

                    <div className="flex items-center justify-center space-x-3 text-gray-400 text-sm">
                        <Clock className="w-4 h-4" />
                        <span>Merci de votre patience</span>
                    </div>
                </div>

                {/* Animation de chargement */}
                <div className="flex justify-center space-x-2">
                    <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce"></div>
                    <div className="w-3 h-3 bg-red-500 rounded-full animate-bounce delay-100"></div>
                    <div className="w-3 h-3 bg-pink-500 rounded-full animate-bounce delay-200"></div>
                </div>

                {/* Footer */}
                <p className="text-center text-gray-500 text-sm mt-8">
                    Pop Movie © 2025
                </p>
            </div>
        </div>
    );
};

export default MaintenancePage;